export function getInitialState(overrides) {
  return Object.assign({
    defaultAgentId: '',
    agentId: '',
    messages: [],
    conversationId: null,
    turnId: null,
    title: null,
    status: 'READY',
    error: null,
    cancelled: false,
    activeTools: [],
    pendingToolResults: new Map(),
    pendingApprovals: new Map(),
    messageQueue: [],
    queueIdCounter: 0,
    historyHasMore: false,
    historyOffset: undefined,
    isLoadingMore: false,
    isReconnecting: false,
    fetchIdCounter: 0,
    messageTurnIdMap: new Map(),
    feedbackByTurnId: new Map(),
    feedbackByCitationKey: new Map()
  }, overrides);
}
export const DELTA_ID_PREFIX = 'delta-';